import React from 'react';
import { StyleSheet } from 'react-native';
import { RNCamera, CameraType } from 'react-native-camera';
import build from '../../config/build';
import { Logger } from '../../utils/Logger';

export const SelfViewComponent = ({ customStyle = {}, zoom = 0 }) => {
  return (
    <RNCamera
      style={[styleSheet.mirrorContainer, customStyle]}
      type={RNCamera.Constants.Type.front}
      captureAudio={false}
      zoom={zoom}
      useCamera2Api={build.variant.isElite}
      onCameraReady={onCameraReady}
      onMountError={onMountError}
      onStatusChange={onStatusChange}
    >
    </RNCamera>
  );
};

const onCameraReady = () => {
  Logger.leaveBreadcrumb('SelfView.onCameraReady');
};

const onMountError = (e) => {
  Logger.leaveBreadcrumb('SelfView.onMountError', e);
};

const onStatusChange = (event) => {
  Logger.leaveBreadcrumb('SelfView.onStatusChange', event);
};

const styleSheet = StyleSheet.create({
  mirrorContainer: {
    flex: 1,
  },
});
